import { render, staticRenderFns } from "./TicketPriorityIcon.vue?vue&type=template&id=c3627fe8&"
import script from "./TicketPriorityIcon.vue?vue&type=script&lang=ts&"
export * from "./TicketPriorityIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports